// src/utils/stripHtml.js

/**
 * Nettoie une chaîne contenant du HTML et retourne uniquement le texte brut.
 * @param {string} html
 * @returns {string}
 */
export const stripHtml = (html) => {
    if (!html) return '';

    // Solution robuste avec DOMParser
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || '';
};



// WEBPACK FOOTER //
// ./src/utils/stripHtml.js